<template>
<div class="page-title">
    <div class="title">
        <h3>QC Enquiries</h3>
    </div>
    <div class="filters">
        <el-form
            label-position="top"
        >
            <el-row>
                <el-col :span="2" >
                    <el-form-item label="Types">
                        <el-select v-model="form.service"  placeholder="Select" size="small" clearable>
                            <el-option
                                v-for="item in data.services"
                                :key="item"
                                :label="item"
                                :value="item"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="2" v-if="form.stage!='Unassigned'">
                    <el-form-item class="ml-2" label="Stage">
                        <el-select v-model="form.stage"  placeholder="Select" size="small" >
                            <el-option
                                v-for="item in stages"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="3" v-if="form.stage!='Unassigned'">
                    <el-form-item class="ml-2" label="Not Contacted">
                        <el-select v-model="form.notcontacted"  placeholder="Select" size="small" clearable>
                            <el-option
                                v-for="item in notcontacted"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="3" v-if="underusers.length>0 && form.stage!='Unassigned'">
                    <el-form-item class="ml-2" label="Agent" size="small">
                        <el-select v-model="form.user" value-key="id" placeholder="Select Agent" clearable>
                            <el-option
                                v-for="item in underusers"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"


                            >

                                <el-avatar class="mr-2 " :size="20" :src="'https://crm.pickotrip.com/images/agents/'+item.name+'.jpg'" />
                                {{ item.name }}



                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="3" >
                    <el-form-item class="ml-2"  label="Destination" size="small">
                        <el-select-v2 style="width:100%" filterable v-model="form.destination" :options="data.destinations"  placeholder="Select Destination" clearable>

                        </el-select-v2>
                    </el-form-item>
                </el-col>


                <el-col :span="4">
                    <el-form-item class="ml-2" label="Date Range" size="small">
                        <el-date-picker
                            v-model="form.daterange"
                            type="daterange"
                            unlink-panels
                            range-separator="-"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            :shortcuts="dateshortcuts"
                            format="DD/MMM/YYYY"
                            value-format="YYYY-MM-DD"


                        />
                    </el-form-item>
                </el-col>


                <el-col :span="2">
                    <el-form-item class="ml-2" label=" .">
                    <el-button @click="form.page=1;getlist()"  type="primary" size="small"  round >Apply Filters</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="2" v-if="lform.ids.length>0">
                    <el-form-item class="ml-2" label=" .">
                        <el-dropdown>
                            <el-button type="primary" size="small"  round>
                                Selected Action
                            </el-button>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item v-if="data.permissions.assign"  @click="assigndialogVisible = true" >Assign</el-dropdown-item>
                                    <el-dropdown-item v-if="data.permissions.close" @click="closedialogVisible = true">Close</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </el-form-item>
                </el-col>




            </el-row>



        </el-form>



    </div>
</div>

    <div v-if="!loading">
        <enquiry-list-card  v-for="enquiry in enquiries" :enquiry="enquiry" :data="data" @actionevent="getlist" @selectchange="selectchange">

        </enquiry-list-card>


        <el-card class="box-card mt-2" v-if="total>0">
            <el-row  >
                <el-col justify="right">

                    <el-space  ></el-space>
                    <el-pagination style="width: fit-content;" v-model:current-page="form.page" class="mt-4 mb-4" v-model:page-size="form.size" background layout="total, sizes, prev, pager, next" :page-sizes="[10, 50, 100, 200,300,400,500,1000]" @current-change="pageChange" @size-change="handleSizeChange" :total="total" />
                    <el-space  ></el-space>

                </el-col>
            </el-row>
        </el-card>


    </div>
    <div v-else>
        <el-card class="box-card mt-2 booking-list-box" v-for="i in 7" :key="i">
            <el-skeleton :rows="1" animated />
        </el-card>

    </div>
    <el-dialog
        v-model="assigndialogVisible"
        title="Assign Enquiries"
        width="30%"
    >
        <el-form
            label-position="top"
            ref="ruleFormRef"
            :model="lform"
            status-icon
            :rules="rules"
        >
            <el-form-item class="ml-2" label="Agent"  prop="assignto">
                <Select2 style="width:100%"  v-model="lform.assignto"   :settings="ajax.userssetting" required/>
            </el-form-item>

        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="primary" @click="assigndialogVisible = false">Cancel</el-button>
            <el-button type="primary" @click="submitForm()" :loading="loading" :disabled="loading">
              Assign
            </el-button>
          </span>
        </template>
    </el-dialog>

    <el-dialog
        v-model="closedialogVisible"
        title="Close Enquiries"
        width="30%"
    >
        <el-form
            label-position="top"
            ref="ruleFormRef2"
            :model="lform"
            status-icon
            :rules="rules"
        >
            <el-form-item label="Your Note"  prop="note">
                <el-input
                    v-model="lform.note"
                    :rows="3"
                    type="textarea"
                    placeholder="Enter Note here"
                />
            </el-form-item>

        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="primary" @click="closedialogVisible = false">Cancel</el-button>
            <el-button type="primary" @click="submitForm2()" :loading="loading" :disabled="loading">
              Close
            </el-button>
          </span>
        </template>
    </el-dialog>
</template>
<style>

</style>
<script>
import  { ElSelectV2,ElDialog,ElDropdownMenu,ElDropdown,ElDropdownItem,ElInput,ElSpace,ElPagination,ElText,ElCollapseItem,ElCollapse,ElSelect, ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton  } from 'element-plus'

import 'element-plus/dist/index.css'
import moment from 'moment'
import $ from "jquery";
export default {
    name: "BookingList",
    components: { ElSelectV2,ElDialog,ElDropdownMenu,ElDropdown,ElDropdownItem,ElInput,ElSpace,ElPagination,ElText,ElCollapseItem,ElCollapse,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton },
    props:{
        etype: {
            type: String,
            default () {
                return "All"
            }
        },
    },
    data() {
        return {
            assigndialogVisible:false,
            closedialogVisible:false,
            data:{
              user:null,
              languages:null,
              destinations:[],
              services:[]
            },

            loading: true,
            total:0,
            rules:{
                assignto: [{ required: true, trigger: 'change', message:'Required' }],
                note: [{ required: true, trigger: 'change', message:'Required' }]
            },
            lform:{
                ids:[],
                assignto:null,
                note:''
            },
            form:{
                page:1,
                stage:'All',
                type:'0',
                daterange:null,
                user:'',
                search:'',
                notcontacted:'',
                size:10,
                destination:'',
                service:''
            },
            stages:[
                // {
                //     value:'Working',
                //     label:'Working'
                // },
                {
                    value:'QuotationSent',
                    label:'Quotation Sent'
                },
                {
                    value:'Pending',
                    label:'Pending'
                },
                {
                    value:'InProgress',
                    label:'InProgress'
                },
                {
                    value:'Closed',
                    label:'Closed'
                },
                {
                    value:'Followup',
                    label:'Followup'
                },
                {
                    value:'Hot',
                    label:'Hot'
                },
                {
                    value:'All',
                    label:'All'
                },
            ],
            notcontacted:[
                {
                    value:'1',
                    label:'More than 1 Day'
                },
                {
                    value:'2',
                    label:'More than 2 Days'
                },
                {
                    value:'3',
                    label:'More than 3 Days'
                },
                {
                    value:'4',
                    label:'More than 4 Days'
                },
                {
                    value:'5',
                    label:'More than 5 Days'
                },
                {
                    value:'1',
                    label:'More than 1 Week'
                },
                {
                    value:'15',
                    label:'More than 15 Days'
                },
                {
                    value:'30',
                    label:'More than 1 Month'
                }
            ],
            enquiries:[],
            underusers:[],
            dateshortcuts : [
                {
                    text: 'This Month',
                    value: () => {

                        return [moment().startOf('month').format('YYYY-MM-DD'),moment().endOf('month').format('YYYY-MM-DD')]
                    },
                },
                {
                    text: 'Last month',
                    value: () => {

                        return [moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')]
                    },
                },
                {
                    text: 'Last 3 months',
                    value: () => {
                        return [moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')]

                    },
                },
            ],
            ajax:{
                userssetting: {
                    ajax: {
                        url: '/myusers',
                        dataType: 'json',
                        delay: 250,
                        processResults: function (data) {
                            return {
                                results: $.map(data, function (item) {
                                    return {
                                        text: item.name,
                                        id: item.id
                                    }
                                })
                            };
                        },
                        cache: true
                    }

                },
            }

        }
    },
    mounted() {
        const notification = {
            title: 'New Enquiry Assigned',
            options: {
                body: 'Rinku / 918448437887 / Thailand',
            },
            events: {
                onerror: function () {
                    console.log('Custom error event was called')
                },
                onclick: function () {
                    console.log('Custom click event was called')
                },
                onclose: function () {
                    console.log('Custom close event was called')
                },
                onshow: function () {
                    console.log('Custom show event was called')
                },
            },
        }
        this.$notification.show(
            notification.title,
            notification.options,
            notification.events,
        )
        this.form.stage=this.etype;
        this.getlist();
    },
    methods: {
        getlist() {
            this.selecteds=[];
            this.loading=true;
            let currentObj = this;
            axios.post('/enquiry/list',this.form).then(function (response) {
                currentObj.enquiries=response.data.enquiries;
                currentObj.underusers=response.data.underusers;
                currentObj.total=response.data.total;
                currentObj.loading=false;
                currentObj.data=response.data.data;

            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        },
        pageChange(page){
            this.form.page=page;
            this.getlist();
        },
        handleSizeChange(size){
            this.form.page=1;
            this.form.size=size;
            this.getlist();
        },
        openenquiry(link){
            window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight);
        },
        selectchange(id,val){

            if(val){
                this.lform.ids.push(id);
            }
            else{
                const filtersList = this.lform.ids.filter(element => element !== id)
                this.lform.ids=filtersList
            }
        },
        submitForm(){
            var formEl=this.$refs.ruleFormRef;
            let currentObj = this;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    currentObj.loading=true;
                    axios.post('/enquiry/multiassign',currentObj.lform).then(function (response) {

                        currentObj.lform.assignto = null
                        currentObj.lform.ids = []
                        toastr.success('Assigned Succesfully.');
                        currentObj.loading=false;
                        currentObj.assigndialogVisible = false;
                        currentObj.getlist();
                    })
                        .catch(function (error) {
                            toastr.error('Something Wrong try again.');
                            currentObj.loading=false;
                        });

                } else {

                    return false
                }
            })
        },
        submitForm2(){
            var formEl=this.$refs.ruleFormRef2;
            let currentObj = this;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    currentObj.loading=true;
                    axios.post('/enquiry/multiclose',currentObj.lform).then(function (response) {

                        currentObj.lform.note = ""
                        currentObj.lform.ids = []
                        toastr.success('Closed Succesfully.');
                        currentObj.loading=false;
                        currentObj.closedialogVisible = false;
                        currentObj.getlist();
                    })
                        .catch(function (error) {
                            toastr.error('Something Wrong try again.');
                            currentObj.loading=false;
                        });

                } else {

                    return false
                }
            })
        },

    }
}
</script>

<style scoped>

</style>
